<template>
  <b-card>
    <b-row>
      <label>Ange lösenord:</label>
    </b-row>
    <b-row> <b-input type="password" v-model="p1"></b-input></b-row>
    <b-row>{{ GetValMsg(p1) }}</b-row>
    <b-row>
      <label>Upprepa lösenord:</label>
    </b-row>
    <b-row><b-input type="password" v-model="p2"></b-input></b-row>
    <b-row>{{ GetValMsg(p2) }}</b-row>
    <b-row v-if="p1 && p2 && (p1 != p2)">Lösenorden matchar inte</b-row>
    <b-row>
      <b-col>
        <b-button @click="OK">Sätt lösenord</b-button>
      </b-col>
      <b-col>
        <!-- <b-button @click="Cancel">Avbryt</b-button> -->
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: "setpassword",
  data() {
    return {
      p1: "",
      p2: "",
    };
  },
  methods: {
    GetValMsg(p) {
      if (p) {
        if (p.indexOf(" ") >= 0) return "Får ej innehålla mellanslag";
        if (p.length < 5) return "Lösenord för kort";
      }
      return "";
    },
    OK() {
      if (this.p1 != this.p2) {
        alert("Lösenorden matchar inte");
        return;
      }
      if (this.GetValMsg(this.p1) != "") {
        alert(this.GetValMsg(this.p1));
        return;
      }
      this.$emit("newpassword", this.p1);
    },
    Cancel() {
      this.$emit("cancel");
    },
  },
};
</script>